import React, { useRef, useState } from "react";
import { Trash2, Plus, ImagePlus, Loader2, ArrowUp, ArrowDown } from "lucide-react";

export function ImageField({ value, onChange, uploadImage }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  async function handleFile(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true);
    setErr("");
    try {
      const result = await uploadImage(file);
      onChange(result.url);
    } catch (ex) {
      setErr("Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  }

  return (
    <div className="admin-image-field">
      {value ? (
        <div className="admin-image-preview">
          <img src={value} alt="" />
        </div>
      ) : null}
      <input
        type="text"
        className="admin-input"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Image URL (or upload)"
      />
      <div className="admin-image-actions">
        <button
          type="button"
          className="admin-btn-ghost"
          onClick={() => inputRef.current && inputRef.current.click()}
          disabled={uploading}
        >
          {uploading ? (
            <span><Loader2 size={13} className="spin" /> Uploading…</span>
          ) : (
            <span><ImagePlus size={13} /> Upload image</span>
          )}
        </button>
        {value ? (
          <button
            type="button"
            className="admin-btn-ghost danger"
            onClick={() => onChange("")}
          >
            <Trash2 size={13} /> Clear
          </button>
        ) : null}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFile}
        style={{ display: "none" }}
      />
      {err ? <div className="admin-error">{err}</div> : null}
    </div>
  );
}

export function StringArrayField({ value, onChange }) {
  const arr = Array.isArray(value) ? value : [];

  function setAt(i, v) {
    const next = arr.slice();
    next[i] = v;
    onChange(next);
  }
  function removeAt(i) {
    onChange(arr.filter((_, idx) => idx !== i));
  }
  function add() {
    onChange(arr.concat([""]));
  }
  function move(i, dir) {
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    const next = arr.slice();
    const tmp = next[i];
    next[i] = next[j];
    next[j] = tmp;
    onChange(next);
  }

  return (
    <div className="admin-str-arr">
      {arr.map((v, i) => (
        <div key={i} className="admin-str-row">
          <textarea
            className="admin-input"
            value={v}
            onChange={(e) => setAt(i, e.target.value)}
            rows={2}
          />
          <div className="admin-str-row-actions">
            <button type="button" className="admin-icon-btn" onClick={() => move(i, -1)} title="Up"><ArrowUp size={13} /></button>
            <button type="button" className="admin-icon-btn" onClick={() => move(i, 1)} title="Down"><ArrowDown size={13} /></button>
            <button type="button" className="admin-icon-btn danger" onClick={() => removeAt(i)} title="Remove"><Trash2 size={13} /></button>
          </div>
        </div>
      ))}
      <button type="button" className="admin-btn-ghost" onClick={add}>
        <Plus size={13} /> Add item
      </button>
    </div>
  );
}

export function getItemLabel(item) {
  if (!item) return "";
  return item.title || item.subject || item.publication || item.label || item.headline || "";
}
